import {defineMessages} from 'react-intl';

export const messages = defineMessages({
    YES: {
        id: 'techDoc.requestForPartner.option.yes',
        defaultMessage: 'Yes'
    },
    NO: {
        id: 'techDoc.requestForPartner.option.no',
        defaultMessage: 'No'
    },
});

export default messages;
